import { Translator } from 'Translator';
import useApprovedLocations from 'hooks/useApprovedLocations';
import { getLocalSearchBasePath } from 'modules/locals/utils/LocalSearchFilterHelper';
import LocalSearchUrlParser, {
  DEFAULT_HOSTS_PER_PAGE,
  FilterObject,
} from 'modules/locals/utils/LocalSearchUrlParser';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';

const INITIAL_STATE: FilterObject = {
  country: '',
  city: '',
  hostType: 'guides',
  activeFilters: [],
  page: 1,
  hostsPerPage: DEFAULT_HOSTS_PER_PAGE,
  redirectUrl: '',
  otherQueryParams: new URLSearchParams(),
};

const getSearchParams = (search) => {
  const searchParamsObject = new URLSearchParams(search);
  searchParamsObject.delete('modal');
  const searchParamsString = searchParamsObject.toString().toLowerCase();
  return `${
    searchParamsString.length > 0
      ? `?${decodeURIComponent(searchParamsString)}`
      : ''
  }`;
};

const useLocalSearchFilter = () => {
  const location = useLocation();
  const history = useHistory();
  const { data: locations } = useApprovedLocations();
  const [filterObject, setActiveFilters] =
    useState<FilterObject>(INITIAL_STATE);

  useEffect(() => {
    if (locations.length === 0) {
      return;
    }
    const newSearchParams = getSearchParams(location.search);
    const url = `${location.pathname}${newSearchParams}`;
    const newFilterObject = LocalSearchUrlParser.parse(url, locations);
    if (newFilterObject.redirectUrl) {
      history.replace(
        generatePathnameWithLangCode(
          `${getLocalSearchBasePath(location.pathname).slice(0, -1)}${
            newFilterObject.redirectUrl
          }`,
          Translator.getLanguageCode(),
        ),
      );
    } else {
      setActiveFilters(newFilterObject);
    }
  }, [location.search, location.pathname, locations, history]);

  return filterObject;
};

export default useLocalSearchFilter;
